import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Package, ChevronRight } from "lucide-react";
import { sizeLabel } from "@/lib/sizes";

const OPEN = new Set(["draft", "requested"]);

const MyParcels = ({ openOnly = false, emptyText = "No parcels yet." }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/parcels/mine").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);
  if (items === null) return null;
  const rows = openOnly ? items.filter((p) => OPEN.has(p.status)) : items;
  if (!rows.length) return (
    <div className="rounded-2xl bg-white border border-slate-200 p-6 text-center text-sm text-slate-500" data-testid="my-parcels-empty">
      <Package className="w-7 h-7 mx-auto mb-2 text-slate-300"/>{emptyText}
    </div>
  );
  return (
    <div className="space-y-2" data-testid="my-parcels-list">
      {rows.map((p) => (
        <Link key={p.id} to={OPEN.has(p.status) ? `/parcel/${p.id}/browse` : `/parcel/${p.id}`} data-testid={`my-parcel-${p.id}`}
              className="flex items-center gap-3 rounded-2xl bg-white border border-slate-200 p-4 hover:border-amber-300 transition-colors">
          <div className="min-w-0 flex-1">
            <div className="font-display font-bold truncate">{p.pickup_location} → {p.drop_location}</div>
            <div className="text-xs text-slate-500 mt-0.5">{sizeLabel(p)} · posted {new Date(p.created_at).toLocaleDateString()}</div>
          </div>
          <Badge className="bg-slate-100 text-slate-700 text-[10px]">{OPEN.has(p.status) ? "FIND A TRAVELLER" : (p.status || "").replace("_", " ").toUpperCase()}</Badge>
          <ChevronRight className="w-4 h-4 text-slate-400"/>
        </Link>
      ))}
    </div>
  );
};

export default MyParcels;
